import type { AuthoredItem } from "../../api/content/authoring/processAuthoringApi";
import ArtifactForm from "./artifacts/ArtifactForm";
import CapabilityOverridesForm from "./capabilities/CapabilityOverridesForm";
import type { AuthoringOptions } from "./draft/authoringOptions";
import LabelListForm from "./labelLists/LabelListForm";
import StepForm from "./steps/StepForm";

interface ItemEditFormProps {
  readonly item: AuthoredItem;
  readonly projectId: string;
  readonly options: AuthoringOptions;
}

/**
 * The form for the next version of an item, starting from `item` (AU-5 "Edit"): a step, an
 * artifact, a label list or capability overrides. One switch for the item's edit page and
 * the "Edit an item" step's view (ADR-0031 D2); `null` for a kind without a form, which is
 * edited in its graph (a Workflow) or with the agent.
 */
export default function ItemEditForm({ item, projectId, options }: ItemEditFormProps) {
  const content = item.content;
  const base = { reference: item.reference, itemId: item.itemId };
  switch (content?.kind) {
    case "step":
      return <StepForm projectId={projectId} options={options} base={{ ...base, definition: content.definition }} />;
    case "label_list":
      return <LabelListForm projectId={projectId} base={{ ...base, content: content.definition }} />;
    case "artifact":
      return <ArtifactForm projectId={projectId} options={options} base={{ ...base, content: content.definition }} />;
    case "capability_overrides":
      return <CapabilityOverridesForm projectId={projectId} base={{ ...base, content: content.definition }} initial={content.definition} />;
    case "workflow":
    case "prompt":
    case "skill":
    case "tool":
    case undefined:
      return null;
  }
}
